import { createActionConst } from '../../../utils/action.utils';

const PAGE_STATE_NAMESPACE = 'PAGE_STATE';

export const STORE_PAGE_STATE_IN_PROGRESS = createActionConst(PAGE_STATE_NAMESPACE, 'STORE_PAGE_STATE_IN_PROGRESS');
export const CLEAR_PAGE_STATE_IN_PROGRESS = createActionConst(PAGE_STATE_NAMESPACE, 'CLEAR_PAGE_STATE_IN_PROGRESS');

export const STORE_PAGE_STATE_ERROR = createActionConst(PAGE_STATE_NAMESPACE, 'STORE_PAGE_STATE_ERROR');
export const CLEAR_PAGE_STATE_ERROR = createActionConst(PAGE_STATE_NAMESPACE, 'CLEAR_PAGE_STATE_ERROR');
